import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TSwedBankIntegrationRequestPayload,
	TSwedBankIntegrationResponsePayload,
	TSwedBankUploadStatementFileRequest,
	TSwedBankSearchInvoicesRequestPayload,
	TSwedBankSearchInvoicesResponsePayload,
	TSwedBankMarkAsProcessedRequestPayload,
	TSwedBankStore,
	TSwedBankMarkAsProcessedRequest,
	TAttachVatReimbursementRequest,
} from './types';
// ==========================================:
export const initialState: TSwedBankStore = {
	swedBankIntegration: null,
	swedBankIntegrationLoader: false,
	uploadStatementFileLoader: false,
	searchInvoicesLoader: false,
	searchInvoices: null,
	markAsProcessedLoader: false,
	attachVatReimbursementLoader: false,
};

// ==========================================:
const swedBank = createSlice({
	name: '@@swedBank',
	initialState,
	reducers: {
		getSwedBankIntegrationRequest: (
			state: TSwedBankStore,
			action: PayloadAction<TSwedBankIntegrationRequestPayload>,
		) => {
			const swedBankState = state;
			swedBankState.swedBankIntegrationLoader = true;
		},
		getSwedBankIntegrationSuccess: (
			state: TSwedBankStore,
			action: PayloadAction<TSwedBankIntegrationResponsePayload>,
		) => {
			const { payload } = action;
			const swedBankState = state;
			swedBankState.swedBankIntegration = payload;
			swedBankState.swedBankIntegrationLoader = false;
		},
		uploadStatementFileRequest: (
			state: TSwedBankStore,
			action: PayloadAction<TSwedBankUploadStatementFileRequest>,
		) => {
			const swedBankState = state;
			swedBankState.uploadStatementFileLoader = true;
		},
		uploadStatementFileSuccess: (state: TSwedBankStore) => {
			const swedBankState = state;
			swedBankState.uploadStatementFileLoader = false;
		},
		searchInvoiceRequest: (
			state: TSwedBankStore,
			action: PayloadAction<TSwedBankSearchInvoicesRequestPayload>,
		) => {
			const swedBankState = state;
			swedBankState.searchInvoicesLoader = true;
		},
		searchInvoiceSuccess: (
			state: TSwedBankStore,
			action: PayloadAction<TSwedBankSearchInvoicesResponsePayload>,
		) => {
			const { payload } = action;
			const swedBankState = state;
			swedBankState.searchInvoices = payload;
			swedBankState.searchInvoicesLoader = false;
		},
		markAsProcessedRequest: (
			state: TSwedBankStore,
			action: PayloadAction<TSwedBankMarkAsProcessedRequest>,
		) => {
			const swedBankState = state;
			swedBankState.markAsProcessedLoader = true;
		},
		markAsProcessedSuccess: (state: TSwedBankStore) => {
			const swedBankState = state;
			swedBankState.markAsProcessedLoader = false;
		},
		attachVatReimbursementRequest: (
			state: TSwedBankStore,
			action: PayloadAction<TAttachVatReimbursementRequest>,
		) => {
			const swedBankState = state;
			swedBankState.attachVatReimbursementLoader = true;
		},
		attachVatReimbursementSuccess: (state: TSwedBankStore) => {
			const swedBankState = state;
			swedBankState.attachVatReimbursementLoader = false;
		},
		swedBankInitState: () => initialState,
	},
});

export default swedBank.reducer;
export const {
	getSwedBankIntegrationRequest,
	getSwedBankIntegrationSuccess,
	uploadStatementFileRequest,
	uploadStatementFileSuccess,
	searchInvoiceRequest,
	searchInvoiceSuccess,
	markAsProcessedRequest,
	markAsProcessedSuccess,
	attachVatReimbursementRequest,
	attachVatReimbursementSuccess,
	swedBankInitState,
} = swedBank.actions;
